














import mixins from 'vue-typed-mixins';
import DataSetFormVue from './DataSetForm.vue';
import DataSetUtils, { DataSet } from '@/utils/DataSetUtils';

export default mixins().extend({
  components: {
    DataSetForm: DataSetFormVue,
  },

  data(): {
    item?: Partial<DataSet>;
  } {
    return {
      item: {
        id: undefined,
        key: undefined,
        name: undefined,
        oversighttype: undefined,
      },
    };
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await DataSetUtils.api.dataset.add(this.item);
          await this.$router.push({ name: 'dataset-list' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
